module.exports = __webpack_public_path__ + "img/social-media-display-bg.4892f61d.png";